import { ProductDetailsResponse, ProductResponse, TrolleyItemResponse } from '@woolworthsnz/trader-api';
import { FulfilmentStoreStockLevelResponse } from '@woolworthsnz/trader-api/esm/model/fulfilmentStoreStockLevelResponse';

export class ProductState implements ProductResponse {
	visible = true;
	completed = false;
	submitted = false;
	error: boolean | any = false;
	hasShopperNotes = false;
	shopperNote: string;
	quantityInTrolley = 0;
	product: ProductResponse | ProductDetailsResponse | null = null;
	selectedPurchasingUnit: ProductResponse.UnitEnum;
	promotionAffectedItems?: Map<string, TrolleyItemResponse> = new Map<string, TrolleyItemResponse>();
	supportsBothEachAndKgPricing: boolean;
	fulfilmentStoreStockLevels?: Array<FulfilmentStoreStockLevelResponse>;
}
